/*
    Create by chenhao 2018-3-20 14:18:11
*/
'use strict';
angular.module("userManaShowUserRoleModalModule", [])
    .controller("userManaShowUserRoleModalCtrl", ["$scope", "$modalInstance", "$state","item", "trsHttpService","modalDialog", function($scope, $modalInstance,$state,item, trsHttpService,modalDialog) {
        initStatus();
        initData();

        function initStatus() {
            $scope.status = {
                params: {
                    "serviceid": "mlf_usermanagement",
                    "methodname": "getRoleGroupPath",
                    "RoleId": ""
                }
            };

            $scope.data = {
                role: [],
                roleLength: "",
                selectedRole: ""
            };
        }

        function initData() {
            var params = {
                "serviceid": "mlf_usermanagement",
                "methodname": "queryUserRoles",
                "UserId": item
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.role = data;
                $scope.data.roleLength = data.length;
                if (angular.isDefined($scope.data.role[0])) {
                    getGroupPathByRoleId($scope.data.role[0].ROLEID, 0);
                }
            });
        }

        /**
         * [getGroupPathByRoleId description] 根据角色ID获取角色所属组织路径
         * @param  {[type]} roleid [description]
         * @param  {[type]} index  [description]
         * @return {[type]}        [description]
         */
        function getGroupPathByRoleId(roleid, index) {
            $scope.status.params.RoleId = roleid;
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.status.params, 'get').then(function(data) {
                if (data.length > 0) {
                    $scope.data.role[index].ROLEGROUPPATH = data[0].ROLEGROUPPATH;
                    $scope.data.role[index].GROUPID = data[0].GROUPID;
                    index++;
                    if (index < $scope.data.role.length) {
                        getGroupPathByRoleId($scope.data.role[index].ROLEID, index);
                    }
                } else {
                    index++;
                    if (index < $scope.data.role.length) {
                        getGroupPathByRoleId($scope.data.role[index].ROLEID, index);
                    }
                }
            }, function() {
                index++;
                if (index < scope.data.role.length) {
                    getGroupPathByRoleId(scope.data.role[index].ROLEID, index);
                }
            });
        }


        /**
         * [handleRolePath description] 处理角色路径文字格式
         * @param {object} [item] [description] 用户信息
         * @return {[type]} [description]
         */
        $scope.handleRolePath = function(item) {
            if (angular.isUndefined(item.ROLEGROUPPATH)) return;
            var rolePathArray = item.ROLEGROUPPATH.split(">");
            rolePathArray = rolePathArray.map(function(data) {
                return "<span class='role_path'>" + data + "</span>";
            });
            var rolePath = rolePathArray.join("<span class='separator'>›</span>");
            rolePath += ("<span class='separator'>›</span><span>" + item.ROLENAME + "</span>");
            return rolePath;
        };

        /**
         * [selectRole description] 选择角色
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectRole = function(item) {
            if ($scope.data.selectedRole == item) {
                $scope.data.selectedRole = "";
            } else {
                $scope.data.selectedRole = item;
            }
        };

        /**
         * [isConfirm description] 确定
         * @return {Boolean} [description]
         */
        $scope.isConfirm = function() {
            if ($scope.data.selectedRole.length == 0) {
                modalDialog.alertType("", "请先选择角色", "info", false);
                return;
            }
            var groupid = $scope.data.selectedRole.GROUPID;
            var roleid = $scope.data.selectedRole.ROLEID;
            $modalInstance.dismiss();
            $state.go("manageconfig.rolemanage.editorcreaterole", { type: 'edit', groupid: groupid, roleid: roleid }, { reload: true });
        };
        //取消
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

    }]);